import { render, staticRenderFns } from "./Snippet.vue?vue&type=template&id=5c0f67be"
import script from "./Snippet.vue?vue&type=script&lang=js"
export * from "./Snippet.vue?vue&type=script&lang=js"
import style0 from "./Snippet.vue?vue&type=style&index=0&id=5c0f67be&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports